import { X } from "lucide-react";

export const RARITIES = ["common", "uncommon", "rare", "elite", "legendary"];
export const SKILLS = ["strength", "speed", "defense", "stamina", "technique", "precision"];

export const inputCls = "w-full bg-zinc-950 border border-amber-900/40 px-3 py-2 text-sm text-zinc-100 focus:border-amber-600 outline-none rounded-sm";

export const Label = ({ children }) => <label className="block text-[11px] uppercase tracking-widest text-zinc-500 mb-1">{children}</label>;

export function Modal({ title, onClose, children, testid }) {
  return (
    <div data-testid={testid} className="fixed inset-0 z-50 bg-black/80 flex items-start justify-center p-4 overflow-y-auto">
      <div className="bg-zinc-950 border border-amber-700/50 max-w-2xl w-full my-8">
        <div className="flex items-center justify-between px-5 py-3 border-b border-amber-900/30 sticky top-0 bg-zinc-950 z-10">
          <h2 className="font-cinzel text-amber-300 uppercase tracking-widest text-sm">{title}</h2>
          <button data-testid="modal-close" onClick={onClose} className="text-zinc-500 hover:text-amber-400"><X size={18} /></button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
